import React from 'react';
import { Modal as AntModal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export default function ConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title = 'Conferma',
  confirmLabel = 'Elimina',
  cancelLabel = 'Annulla',
  loading = false,
  children,
}) {
  return (
    <AntModal
      title={(
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: 20 }} />
          <span>{title}</span>
        </div>
      )}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>{cancelLabel}</Button>,
        <Button key="ok" type="primary" danger onClick={onConfirm} loading={loading}>{confirmLabel}</Button>,
      ]}
      centered
      width={450}
    >
      {children}
    </AntModal>
  );
}
